import { PayloadAction } from "@reduxjs/toolkit";
import { AlertHelper } from "helpers";
import { EAlertType } from "helpers/alertHelper";
import {
  IApiResponse,
  IErrorResponse,
  IImportProductionPlanRequest,
} from "model";
import { call, put, takeEvery } from "redux-saga/effects";
import { ProductionPlanActions } from "redux/actions";
import { ProductionPlanApiService } from "services";

function* importProductionPlan(
  action: PayloadAction<IImportProductionPlanRequest>
) {
  try {
    const result: IApiResponse<any> = yield call(
      ProductionPlanApiService.importProductionPlan,
      action.payload
    );
    if (result.succeeded) {
      yield put(ProductionPlanActions.importProductionPlan.success());
      AlertHelper.showAlert(
        "Import Production Plan Successfully",
        EAlertType.SUCCESS
      );
    } else {
      const error = result as IErrorResponse;
      yield put(ProductionPlanActions.importProductionPlan.failed(error));
    }
  } catch (error) {
    yield put(ProductionPlanActions.importProductionPlan.failed(error));
  }
}

export function* Watcher() {
  yield takeEvery(
    ProductionPlanActions.importProductionPlan.request,
    importProductionPlan
  );
}
